/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
import React from 'react';
import CustomTable from "../../../../components/table/CustomTable";
import EmployeeDocsTableApp from "./Functionality/EmployeeDocsTableApp";
import {permissionObj} from "../../../../Helpers/permission";
import SearchSimple from "../../../../components/SearchSimples/SearchSimple";
import CustomButtonLink from "../../../../components/buttons/CustomButtonLink";

const EmployeeDocsTab = ({selectDocForDelete, setSelectDocForDelete, isAllChecked, modified, setModified, setIsAllChecked, handleAction, canCreate, onCreate}) => {
    const {t, DEV, permission, tableId, searchId, thead, tbody, getActionsButtons, handleCheckboxChange, handleDeleteAll, pagination, page, rowsPerPage,
        setBodyForExport,
        results,
        setResults,
        searchElement,
        setSearchElement,
        option,
        simpleSearch,
        setSimpleSearch,
        setSearch
    } = EmployeeDocsTableApp({
        selectedList: selectDocForDelete,
        setSelectedList:setSelectDocForDelete,
        modified,
        setModified,
        setIsAllChecked,
        handleAction
    });

    return (
        <div className={"row mt-4"}>
            <div className={"col-12 p-0"}>
                <SearchSimple
                    id={searchId}
                    setBodyForExport={setBodyForExport}
                    setSearchResults={setResults}
                    searchResults={results}
                    searchElement={searchElement}
                    setSearchElement={setSearchElement}
                    optionTable={option}
                    rowsPerPage={rowsPerPage}
                    setSearch={setSearch}
                    simpleSearch={simpleSearch}
                    setSimpleSearch={setSimpleSearch}
                    contractorId={null}
                    supplierId={null}
                />
            </div>
            <CustomTable tableId={tableId}
                         searchId={searchId}
                         checkbox={DEV || permission?.includes(permissionObj?.WEB_EMPLOYEE_DOCUMENT_DELETE)}
                         checkboxTitle={"de_/_select_all"}
                         isAllChecked={isAllChecked}
                         onChangeCheckbox={handleDeleteAll}
                         thead={thead}
                         tbody={tbody}
                         columnActions={true}
                         getActionsButtons={getActionsButtons}
                         handleCheckboxChange={handleCheckboxChange}
                         selectedList={selectDocForDelete}
                         textNotInformation={'you_haven_not_created_any_document_yet'}
                         childrenNotInformation={tbody?.body?.length === 0 ? <>
                                 <div className={"warning-text"}>
                                     <p>{t('you_haven_not_created_any_document_yet')}</p>
                                 </div>
                                 { canCreate &&
                                     <CustomButtonLink splitName={false} id={'btn_edt_create'} card={true}
                                                       onClick={onCreate}
                                                       name={'create_new_document'}/>
                                 } </>
                             : undefined
                         }
            />

            { pagination() }
        </div>
    );
};

export default EmployeeDocsTab;
